"use strict";

;
(function (HomepageProducts, $) {
  HomepageProducts.init = function () {
    $('.hp-products-container .product').tooltip({
      position: {
        my: 'center bottom-20',
        at: 'center top',
        using: function using(position, feedback) {
          $(this).css(position);
          $('<div>').addClass('arrow').addClass(feedback.vertical).addClass(feedback.horizontal).appendTo(this);
        }
      }
    });
    $('.hp-products-container .product').each(function () {
      $(this).tooltip('option', 'classes.ui-tooltip', $(this).attr('data-tooltip'));
    });
  };
})(window.HomepageProducts = window.HomepageProducts || {}, jQuery, undefined);